import React from 'react';
import { InputCheckbox } from '@sm360/widget-commons-forms';
import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';
import 'inventory-listing/components/ListingFilters/Components/ListingFiltersDriveTrain/DriveTrain.scss';

const DriveTrain = ({ driveTrain, handleChange }) => (
    <div className="listing-used-drivetrain">
        <InputCheckbox
            label={driveTrain.label}
            value={driveTrain.code.toString()}
            valueChange={() => handleChange(driveTrain.code)}
            isSelected={driveTrain.isSelected}
        />
    </div>
);

DriveTrain.propTypes = {
    driveTrain: React.PropTypes.instanceOf(MetaDataModel).isRequired,
    handleChange: React.PropTypes.func.isRequired,
};

DriveTrain.displayName = 'DriveTrain';

export default DriveTrain;



// WEBPACK FOOTER //
// ./client/src/components/ListingFilters/Components/ListingFiltersDriveTrain/DriveTrain.jsx